// extracted by mini-css-extract-plugin
module.exports = {"headline":"Monitoring_headline__29NNG"};